module.exports = __webpack_public_path__ + "img/top-0-2.ba029e51.jpg";